// extracted by mini-css-extract-plugin
module.exports = {"Light":"Light_Light__oybBF","Active":"Light_Active__1x-tI"};